(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('.policy-modal').forEach(function(modal) {
    document.body.appendChild(modal);
  });

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.policy-modal-trigger');
    if (trigger) {
      e.preventDefault();
      const modalId = trigger.getAttribute('data-policy-modal');
      const modal = document.getElementById(modalId);
      if (modal) modal.removeAttribute('hidden');
    }
    if (e.target.hasAttribute('data-policy-modal-close')) {
      const modal = e.target.closest('.policy-modal');
      if (modal) modal.setAttribute('hidden', true);
    }
  });

  /* ===== Popup paginado de Política de Cambios (capa superior, encima del checkout) ===== */
  (function() {
    var dlg = document.getElementById('vp-pol-dialog');
    if (!dlg) return;

    /* Respaldo para navegadores muy antiguos: se comporta como antes */
    if (typeof dlg.showModal !== 'function') {
      document.documentElement.classList.add('vp-legacy');
      Array.prototype.slice.call(dlg.querySelectorAll('.vp-ov')).forEach(function(p) {
        document.body.appendChild(p);
      });
      return;
    }

    document.body.appendChild(dlg);
    var pushed = false;

    function pages() { return dlg.querySelectorAll('.vp-ov'); }

    function polId(href) {
      var m = (href || '').match(/#(vp-pol-\d+)/);
      return m ? m[1] : null;
    }

    function showPage(id) {
      var target = id ? document.getElementById(id) : null;
      if (!target || !dlg.contains(target)) return false;
      pages().forEach(function(p) { p.classList.remove('vp-show'); });
      target.classList.add('vp-show');
      var box = target.querySelector('.vp-box');
      if (box) box.scrollTop = 0;
      return true;
    }

    function openPol(id) {
      if (!showPage(id)) return;
      if (!dlg.open) {
        dlg.showModal();
        try { history.pushState({ vpPol: true }, ''); pushed = true; } catch (err) {}
      }
    }

    function finish() {
      pages().forEach(function(p) { p.classList.remove('vp-show'); });
      if (dlg.open) dlg.close();
    }

    function closePol() {
      finish();
      if (pushed) { pushed = false; history.back(); }
    }

    /* Links que abren el popup desde fuera (formulario EasySell u otros) */
    document.addEventListener('click', function(e) {
      var a = e.target.closest ? e.target.closest('a[href*="#vp-pol-"]') : null;
      if (!a || dlg.contains(a)) return;
      e.preventDefault();
      e.stopPropagation();
      openPol(polId(a.getAttribute('href')));
    }, true);

    /* Clics dentro del popup: X, Siguiente, Atrás y zona oscura */
    dlg.addEventListener('click', function(e) {
      e.stopPropagation();
      var a = e.target.closest('a');
      if (a) {
        if (a.classList.contains('vp-x')) { e.preventDefault(); closePol(); return; }
        var id = polId(a.getAttribute('href'));
        if (id) { e.preventDefault(); showPage(id); }
        return;
      }
      if (e.target === dlg || e.target.classList.contains('vp-ov')) closePol();
    });

    /* Tecla Esc */
    dlg.addEventListener('cancel', function(e) { e.preventDefault(); closePol(); });
    dlg.addEventListener('keydown', function(e) { if (e.key === 'Escape') e.stopPropagation(); });

    /* Botón atrás del celular: cierra el popup en vez de salir de la página */
    window.addEventListener('popstate', function() {
      if (dlg.open) { pushed = false; finish(); }
    });

    /* Si la dirección trae #vp-pol-N (link antiguo o compartido) */
    function fromHash() {
      var m = location.hash.match(/^#(vp-pol-\d+)$/);
      if (!m) return;
      try { history.replaceState(history.state, '', location.pathname + location.search); } catch (err) {}
      openPol(m[1]);
    }
    window.addEventListener('hashchange', fromHash);
    fromHash();
  })();

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
